import { useEffect, useRef } from "react";

/**
 * Only updates the state if it's passed a non-nullish value,
 * otherwise persists the last one.
 */
const useLastNonNullishValue = <T>(passed: T | null = null): T | null => {
  const ref = useRef<T | null>(passed);

  useEffect(() => {
    ref.current = passed;
  }, [passed]);

  return passed ?? ref.current;
};

export default useLastNonNullishValue;
